
import { z } from "zod";

export const ConversationTypeValues = ["PHONE", "EMAIL", "INTERNAL"] as const;
export const ConversationTypeSchema = z.enum(ConversationTypeValues);
export const ConversationType = ConversationTypeSchema.enum;
export type ConversationType = (typeof ConversationTypeValues)[number];
export const ConversationTypeDisplayNames = { "PHONE": "Phone",
"EMAIL": "Email",
"INTERNAL": "Message", } satisfies Record<ConversationType, string>;
